import React from 'react';
import { Box, Typography, Card, CardContent, Button, useTheme, useMediaQuery } from '@mui/material';
import QuantityControl from './ProductButtonsBuy';
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined';

const getColor = (text) => {
  if (!text) return "var(--info)";
  if (text.includes("Oferta")) return "var(--success)";
  if (text.includes("Lista")) return "var(--purple)";
  if (text.includes("Disponible")) return "var(--info)";
  if (text.includes("Ultimas")) return "var(--warning)";
  if (text.includes("Sin Stock")) return "var(--text-muted)";
  return "var(--success)";
};

export const ProductCardGrid = ({ imgSrc, altText, title, code, price, id, priceOld, percentage, installment, isLogin, isCheckStock, isStockAvailable, stockLimit, isStockFractional, isInCart, idItem, cantItem, isInFav, idFav, onQtyChange, loading, handleCartAdd, handleCartDelete, handleAddFavorito, handleDeleteFavorito, handleClickTitle }) => {
  const theme = useTheme(); const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const increase = () => { if (isInCart) onQtyChange(idItem, cantItem + 1, id); else onQtyChange(null, 1, id); };
  const decrease = () => { if (isInCart) onQtyChange(idItem, cantItem - 1, id); };
  const textColor = getColor(installment);
  return (
    <Card sx={{ border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', boxShadow: 'none', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor: 'var(--bg-card)', transition: 'all 0.3s ease', '&:hover': { borderColor: 'var(--border-hover)', boxShadow: 'var(--shadow-card-hover)', transform: 'translateY(-3px)' } }}>
      {/* Image */}
      <Box sx={{ position: 'relative', height: { xs: 160, sm: 180 }, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--bg-subtle)', overflow: 'hidden', cursor: 'pointer' }} onClick={handleClickTitle}>
        <img src={imgSrc} alt={altText} style={{ maxHeight: '85%', maxWidth: '85%', objectFit: 'contain', transition: 'transform 0.3s ease' }} />
        {percentage > 0 && installment?.toLowerCase().includes("oferta") && (
          <Box sx={{ position: 'absolute', top: 8, left: 8, backgroundColor: textColor, color: '#fff', fontWeight: 800, fontSize: '0.7rem', fontFamily: 'var(--font-heading)', padding: '3px 8px', borderRadius: 'var(--radius-full)', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>-{percentage}%</Box>
        )}
        {isInFav && <Box sx={{ position: 'absolute', top: 8, left: 8, width: 24, height: 24, borderRadius: '50%', backgroundColor: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 12, boxShadow: 'var(--shadow-sm)', zIndex: 2 }}>♥</Box>}
        {isInCart && <Box sx={{ position: 'absolute', top: 8, right: 8, width: 24, height: 24, borderRadius: '50%', backgroundColor: 'var(--success)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14, fontWeight: 700, boxShadow: 'var(--shadow-sm)', zIndex: 2 }}>✓</Box>}
        {isLogin && (
          <Box sx={{ position: 'absolute', bottom: 0, left: 0, width: '100%', background: 'linear-gradient(transparent, rgba(0,0,0,0.5))', padding: '12px 8px 6px', display: 'flex', justifyContent: 'center', opacity: 0, transition: 'opacity 0.25s ease', '.MuiCard-root:hover &': { opacity: 1 } }}>
            <Box onClick={(e) => { e.stopPropagation(); isInFav ? handleDeleteFavorito(idFav) : handleAddFavorito(id); }} sx={{ backgroundColor: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(4px)', padding: '4px 14px', borderRadius: 'var(--radius-full)', cursor: 'pointer', fontSize: '0.72rem', fontWeight: 700, color: '#fff', fontFamily: 'var(--font-body)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' } }}>{isInFav ? "Quitar Favorito" : "♥ Favorito"}</Box>
          </Box>
        )}
      </Box>

      <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5, p: '12px !important', '&:last-child': { pb: '12px !important' } }}>
        {code && <Typography variant="caption" sx={{ fontFamily: 'var(--font-mono)', fontSize: '0.65rem', color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>COD: {code}</Typography>}
        <Typography
  onClick={handleClickTitle}
  sx={{
    fontSize: '0.82rem',
    fontWeight: 600,
    fontFamily: 'var(--font-heading)',
    color: 'var(--text-primary)',
    lineHeight: 1.3,
    cursor: 'pointer',

    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    overflow: 'hidden',

    '&:hover': {
      color: 'var(--accent)',
    },
  }}
>
  {title}
</Typography>

        <Box onClick={handleClickTitle} sx={{ cursor: 'pointer', mt: 0.5 }}>
          <Typography sx={{ fontSize: '1.2rem', fontWeight: 800, fontFamily: 'var(--font-heading)', color: textColor, letterSpacing: '-0.02em', lineHeight: 1 }}>{price}</Typography>
          {priceOld && installment?.toLowerCase().includes("oferta") && (<Typography sx={{ fontSize: '0.75rem', color: 'var(--price-old)', textDecoration: 'line-through', fontFamily: 'var(--font-mono)' }}>{priceOld}</Typography>)}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
          {installment && <Box sx={{ display: 'inline-flex', alignSelf: 'flex-start', padding: '2px 8px', backgroundColor: textColor, color: '#fff', borderRadius: 'var(--radius-full)', fontWeight: 700, fontSize: '0.65rem', fontFamily: 'var(--font-body)' }}>{installment}</Box>}
          {isStockFractional && <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.3, padding: '2px 8px', backgroundColor: '#09566d', color: '#fff', borderRadius: 'var(--radius-full)', fontWeight: 700, fontSize: '0.65rem', fontFamily: 'var(--font-body)' }}><ScaleOutlinedIcon sx={{ fontSize: 11 }} />Fracc.</Box>}
        </Box>
        <Box sx={{ flex: 1 }} />
        <Box sx={{ mt: 1 }}>
          <QuantityControl isLogin={isLogin} isCheckStock={isCheckStock} isStockFractional={isStockFractional} isStockAvailable={isStockAvailable} stockLimit={stockLimit} qty={cantItem} increase={increase} decrease={decrease} loading={loading} onAddToCart={handleCartAdd} onDeleteToCart={handleCartDelete} isInCart={isInCart} />
        </Box>
      </CardContent>
    </Card>
  );
};
export default ProductCardGrid;
